import { useEffect, useRef } from 'react';

export const useMounted = (): { current: boolean } => {
  const mounted = useRef(true);
  useEffect(
    () => (): void => {
      mounted.current = false;
    },
    [],
  );
  return mounted;
};
